import React from 'react';
import ScrollableContainerView, { ScrollableContainerViewProps } from './ScrollableContainerView';

export interface ScrollableContainerPresenterProps extends ScrollableContainerViewProps {
  // Future business logic can be added here
}

export default function ScrollableContainerPresenter(props: ScrollableContainerPresenterProps) {
  return <ScrollableContainerView {...props} />;
}
